import React, { useState, Fragment, useEffect } from "react"
import PropTypes from "prop-types"
import { Row, Col, Modal } from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import { getSkills, editSkillClean, addSkillClean } from "../../store/actions"
import "../../assets/scss/datatables.scss"
import { useDispatch, useSelector } from "react-redux"
import SkillsForm from "./SkillsForm"

const SkillsListTable = props => {
  const dispatch = useDispatch()
  const { SearchBar } = Search

  const [insertModal, setInsertModal] = useState(false)
  const [updateModal, setUpdateModal] = useState(false)
  const [skill, setSkill] = useState({
    idAbility: 0,
  })

  const { error, loading, done, skills } = useSelector(state => ({
    error: state.SkillsList.error,
    loading: state.SkillsList.loading,
    skills: state.SkillsList.skills,
    done: state.SkillsList.done,
  }))

  useEffect(() => {
    dispatch(getSkills())
  }, [])

  const handleEdit = skill => {
    setSkill(skill)
    setUpdateModal(true)
  }

  const buttonActions = (cell, row, rowIndex, extraData) => {
    const active = extraData?.active ?? 0
    return (
      <button
        className="btn btn-primary"
        onClick={() => handleEdit(row)}
        key={`button-${row.idAbility}`}
      >
        Editar
      </button>
    )
  }

  const columns = [
    {
      dataField: "idAbility",
      text: "Id",
      sort: false,
      hidden: true,
    },
    {
      dataField: "ability",
      text: "Nombre de la habilidad",
      sort: true,
    },
    {
      dataField: "estatus",
      text: "Estatus",
      sort: true,
      align: "center",
      headerAlign: "center",
      // eslint-disable-next-line react/display-name
      formatter: (cell, row, rowIndex, extraData) => {
        return (
          <h4 style={{ marginBottom: 0 }} key={`status-${row.idAbility}`}>
            <span
              className={`pt-2 badge bg-${row.estatus ? "success" : "warning"}`}
            >
              {row.estatus ? "Activo" : "Inactivo"}
            </span>
          </h4>
        )
      },
    },
    {
      dataField: "actions",
      text: "Acciones",
      sort: false,
      align: "center",
      headerAlign: "center",
      headerStyle: {
        width: "150px",
      },
      formatter: buttonActions,
    },
  ]

  const pageOptions = {
    sizePerPage: 10,
    totalSize: skills?.length,
    custom: true,
    showTotal: true,
  }

  const defaultSorted = [{ dataField: "ability", order: "asc" }]

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
  }

  return loading || skills === undefined ? (
    <div className="mt-3 mb-3">
      <div className="spinner-chase">
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
      </div>
    </div>
  ) : (
    <Fragment>
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="idAbility"
        columns={columns}
        data={skills}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="idAbility"
            columns={columns}
            data={skills}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <Row className="mb-2 pt-3">
                  <Col lg={2} md={3} sm={4} xs={6}>
                    <div className="d-grid">
                      <button
                        className="btn btn-primary btn-rounded"
                        onClick={() => setInsertModal(true)}
                      >
                        <i className="fa fa-plus"></i> Agregar habilidad
                      </button>
                    </div>
                  </Col>
                  <Col
                    lg={{ size: 2, offset: 8 }}
                    md={{ size: 3, offset: 6 }}
                    sm={{ size: 4, offset: 4 }}
                    xs={6}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <SearchBar
                          {...toolkitProps.searchProps}
                          placeholder="Buscar"
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <Fragment>
                      <BootstrapTable
                        keyField={"idAbility"}
                        bordered={false}
                        striped={true}
                        defaultSorted={defaultSorted}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"thead-light"}
                        {...toolkitProps.baseProps}
                        {...paginationTableProps}
                      />
                      {skills?.length <= 0 && (
                        <Row>
                          <Col md={12} className="text-center">
                            -- No hay registros --
                          </Col>
                        </Row>
                      )}
                    </Fragment>
                  </Col>
                </Row>

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
      <Modal
        isOpen={insertModal}
        backdrop={"static"}
        size="lg"
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title">Registrar habilidad</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setInsertModal(false)
            }}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <SkillsForm
            onDone={() => {
              dispatch(addSkillClean())
              dispatch(getSkills())
              setInsertModal(false)
            }}
            onCancel={() => {
              dispatch(addSkillClean())
              setInsertModal(false)
            }}
            insert={true}
            skill={{
              idAbility: 0,
              ability: "",
              estatus: true,
            }}
          />
        </div>
      </Modal>
      <Modal
        isOpen={updateModal}
        backdrop={"static"}
        size="lg"
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title">Editar habilidad</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setUpdateModal(false)
            }}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <SkillsForm
            onDone={() => {
              dispatch(editSkillClean())
              dispatch(getSkills())
              setUpdateModal(false)
            }}
            onCancel={() => {
              dispatch(editSkillClean())
              setUpdateModal(false)
            }}
            insert={false}
            skill={skill}
          />
        </div>
      </Modal>
    </Fragment>
  )
}

SkillsListTable.propTypes = {
  skills: PropTypes.array,
}

export default SkillsListTable
